var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cart_summary" },
    [
      _c(
        "shipping_bar",
        _vm._b(
          { attrs: { id: "cartSummaryShippingBarwd" } },
          "shipping_bar",
          _vm.shippingBarProps,
          false
        )
      ),
      _vm._v(" "),
      _c("h3", [_vm._v("Subtotal")]),
      _vm._v(" "),
      _c(
        "span",
        {
          domProps: {
            innerHTML: _vm._s(
              _vm.$options.filters.withCurrency(
                _vm.$options.filters.money(_vm.cartTotal)
              )
            ),
          },
        },
        [_vm._v(_vm._s(_vm._f("money")(_vm.cartTotal)))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }